module.exports = __webpack_public_path__ + "static/media/stage.843d207c.png";